<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <b-card
          body-class="p-2 d-flex flex-column flex-sm-column flex-md-row justify-content-between"
          class="shadow-sm"
          border-variant="white"
        >
          <h4 class="m-0 font-weight-bold text-center text-md-left">
            <i class="fas fa-star"></i> MALAY LOTTERY
          </h4>
          <div>
            <b-badge variant="warning" class="goldenrod w-100">ผลรางวัลออกเลขตามสลากหวย (หวยมาเลย์)</b-badge>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col>
        <b-card body-class="p-2" class="shadow-sm" border-variant="white">
          <b-row>
            <b-col class="pr-md-1">
              <b-badge variant="dark" class="mr-2 mb-2">ประจำวันที่</b-badge>{{ result ? result.lottoDate : '' }}
            </b-col>
          </b-row>
          <div class="w-100 p-1 mt-2">
            <div class="row px-2">
              <div class="col-12 col-sm-12 col-md-6 px-1">
                <div class="card border-dark text-center mb-2">
                  <div class="card-header p-1">
                    <b>สี่ตัวตรง</b>
                    <br />
                    <small>(มูลค่า 90,000 บาท )</small>
                  </div>
                  <div class="card-body p-1">
                    <h3 class="card-text font-mitr">{{result ? result.fourResult : ''}}</h3>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-6 px-1">
                <div class="card border-dark text-center mb-2">
                  <div class="card-header p-1">
                    <b>สามตัวตรง</b>
                    <br />
                    <small>(มูลค่า 30,000 บาท )</small>
                  </div>
                  <div class="card-body p-1">
                    <h3 class="card-text font-mitr">{{result ? result.threeResult : ''}}</h3>
                  </div>
                </div>
              </div>
            </div>

            <div class="row px-2">
              <div class="col-6 col-sm-6 col-md-3 p-1">
                <div class="card border-dark text-center">
                  <div class="card-header p-1">
                    <b>สี่ตัวโต๊ด</b>
                    <br />
                    <small style="line-height:1.2;display:inline-block;">(4,000 ฿)</small>
                  </div>
                  <div class="card-body p-1">
                    <h5 class="card-text font-mitr">{{result ? result.fourResult : ''}}</h5>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-6 col-md-3 p-1">
                <div class="card border-dark text-center">
                  <div class="card-header p-1">
                    <b>สามตัวโต๊ด</b>
                    <br />
                    <small style="line-height:1.2;display:inline-block;">(3,000 ฿)</small>
                  </div>
                  <div class="card-body p-1">
                    <h5 class="card-text font-mitr">{{result ? result.threeResult : ''}}</h5>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-6 col-md-3 p-1">
                <div class="card border-dark text-center">
                  <div class="card-header p-1">
                    <b>สองตัวหน้า</b>
                    <br />
                    <small style="line-height:1.2;display:inline-block;">(1,400 ฿)</small>
                  </div>
                  <div class="card-body p-1">
                    <h5 class="card-text font-mitr">{{result ? result.twoFirst : ''}}</h5>
                  </div>
                </div>
              </div>

              <div class="col-6 col-sm-6 col-md-3 p-1">
                <div class="card border-dark text-center">
                  <div class="card-header p-1">
                    <b>สองตัวหลัง</b>
                    <br />
                    <small style="line-height:1.2;display:inline-block;">(1,400 ฿)</small>
                  </div>
                  <div class="card-body p-1">
                    <h5 class="card-text font-mitr">{{result ? result.twoLast : ''}}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
export default {
  name: "Result",
  props:['lottoInfo'],
  data(){
    // console.log(this.lottoInfo);
    return {
      // result: null
    };
  },
  created() {
    // this.getLottoResult();
  },
  method:{
    // getLottoResult() {
    //   this.result = this.lottoInfo.result;
    //   console.log(this.result);
    // }
  },
  computed: {
    result() {
      return this.lottoInfo.result;
    }
  }
};
</script>

<style lang="scss" scoped>
.goldenrod {
  background-color: goldenrod;
  font-weight: normal;
  color: #fff;
}

.text-gold {
  color: rgb(189, 132, 41) !important;
}

.gold-box {
  background-image: linear-gradient(
    160deg,
    #a54e07,
    #b47e11,
    #fef1a2,
    #bc881b,
    #a54e07
  );
  border: 1px solid #a55d07 !important;
  text-shadow: black 1px 1px 3px;
}

.font-mitr {
  font-family: "Mitr", sans-serif;
}

h5.card-text {
  color: #000;
}
</style>